import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@/lib/utils';

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    container?: HTMLElement | null;
  }
>(({ className, align = 'start', sideOffset = 4, container, ...props }, ref) => (
  <PopoverPrimitive.Portal container={container ?? undefined}>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-[2100] w-auto min-w-[12rem] rounded-xl border border-solid border-[var(--inv-border)] bg-[var(--inv-surface)] p-1 shadow-[var(--inv-shadow-hover,0_10px_24px_rgba(43,33,24,0.08))] outline-none',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

const getAddRepoDrawerPortal = () =>
  typeof document === 'undefined'
    ? undefined
    : document.querySelector<HTMLElement>('[data-add-repo-drawer]') ?? undefined;

function usePopoverListWheelScroll(open: boolean) {
  const ref = React.useRef<HTMLUListElement>(null);

  React.useEffect(() => {
    const node = ref.current;
    if (!open || !node) return;

    const onWheel = (event: WheelEvent) => {
      event.stopPropagation();
      if (node.scrollHeight <= node.clientHeight) return;
      node.scrollTop += event.deltaY;
      event.preventDefault();
    };

    node.addEventListener('wheel', onWheel, { capture: true, passive: false });
    return () => node.removeEventListener('wheel', onWheel, { capture: true });
  }, [open]);

  return ref;
}

export {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverAnchor,
  getAddRepoDrawerPortal,
  usePopoverListWheelScroll,
};
